import {DocRenderer} from '@cyntler/react-doc-viewer';
import React, {useContext} from 'react';
import HTMLViewer from '../CustomViewers/HTMLViewer';
// import {HTMLViewerRefContext} from '../CustomDocViewer';

const HTMLRenderer: DocRenderer = ({mainState: {currentDocument}}) => {
  const base64Content = currentDocument?.uri?.split(',')[1] || '';
  // const htmlViewerRef = useContext(HTMLViewerRefContext);

 return <HTMLViewer base64Html={base64Content} />;
};

HTMLRenderer.fileTypes = ['html', 'HTML', 'text/html'];
HTMLRenderer.weight = 1;

export default HTMLRenderer;
